export default {
	logout: 'تسجيل خروج'
}